import {renderLocationItem, renderLocationsContainer} from "../utils/templates.js";

export default class LocationsStep {
    constructor() {
        this.id = "locations";
        this.title_key = "choose_location";
    }

    init({$, state, data, emit}) {
        this.$ = $
        this.state = state;
        this.data = data;
        this.emit = emit;
        this.selected = state.selectedLocation || null;
    }

    render(container) {
        const locationsHtml = this.data.allLocations.map(location => {
            return renderLocationItem({location: location });
        }).join('');

        const html = renderLocationsContainer({
            locationsHtml: locationsHtml,
        });

        container.html(html);

        // bind click events after render
        container.find('.step-specialist-block').on('click', (e) => {
            this.selected = parseInt($(e.currentTarget).data('location-id'), 10);
            this.next();                 // move to next step
        });
    }

    next() {
        if (this.selected) {
            this.state.selectedLocation = this.selected;
            this.emit('location_selected', this.selected);
        }
    }
}